<template>
    <v-overlay z-index="100" :opacity="0.4" :value="value">
        <v-snackbar
            class="RemoveBlock"
            :timeout="1000000"
            top
            :value="value"
        >
            <div class="workOrderRemove_title">{{ title }}</div>
            <v-flex d-flex justify-end>
                <v-btn
                    small
                    color="green"
                    class="mt-0 ml-auto"
                    text
                    :loading="preloader"
                    @click="onRemoveItem"
                >Ok
                </v-btn>
                <v-btn small color="red" class="mt-0" text @click="onRemoveClose">Close</v-btn>
            </v-flex>
        </v-snackbar>
    </v-overlay>
</template>

<script>
export default {
	name: "RemoveBlock",
	props: {
		title: {
			type: String,
			default: () => 'Do you confirm the deletion?'
		},
		isRemove: Boolean,
		preloader: Boolean,
		zIndex: {
			type: String,
			default: () => '10000'
		}
	},
	data: () => ({
		value: true
	}),
	methods: {
		onRemoveItem() {
			this.$emit('updateRemoveItem');
		},
		onRemoveClose() {
			this.$emit('updateRemoveClose');
		}
	}
};
</script>

<style lang="scss">
.RemoveBlock {
    &_title {
        margin-bottom: 15px;
    }
    .v-snack__wrapper {
        box-shadow: none !important;
        background-color: #22222d;
    }
}
</style>
